import makeStyles from '@mui/styles/makeStyles';
import { StylesProps } from ".";

const styles = makeStyles((theme) => ({
  button: {
    backgroundColor: (props: StylesProps) => props?.background?.color || "transparent",
    color: (props: StylesProps) => props?.text?.color || "#FFFFFF",
    fontFamily: "Inter",
    fontSize: "12px",
    fontStyle: "normal",
    lineHeight: "15px",
    height: "40px",
    borderRadius: "8px",
    fontWeight: 700,
    textTransform: "none",
    padding: "10px",
    "& .MuiButton-startIcon": {
      marginLeft: 0,
    },
    "&:hover": {
      backgroundColor: (props: StylesProps) => props?.background?.hoverColor || "transparent",
      color: (props: StylesProps) => props?.text?.hoverColor || "#FFFFFF",
    },
    "&:active": {
      backgroundColor: (props: StylesProps) => props?.background?.activeColor || "transparent",
      color: (props: StylesProps) => props?.text?.activeColor || "#FFFFFF",
    },
    "&:disabled": {
      backgroundColor: (props: StylesProps) => props?.background?.disabledColor || "transparent",
      color: (props: StylesProps) => props?.text?.disabledColor || "#FFFFFF",
      opacity: 0.5,
    },
  },
  circularProgress: {
    color: "#FFFFFF",
  },
}));

export default styles;
